module.exports = __webpack_public_path__ + "img/dead-chicken.358aa0eb.png";